export const PROMOTION_COVER_WIDTH = 312;
export const PROMOTION_COVER_HEIGHT = 175;

export const WHATSAPP_ICON_SIZE = 18;

export const AUTHORISED_DISTRIBUTORS = 'ad';
export const PARALLEL_IMPORTERS = 'pi';

export const PROMOTION_DEALER_INFO_ICON_SIZE = 16;
